import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BorrowerFinancesSmartComponent } from './borrower-finances-smart/borrower-finances-smart.component';
import { BorrowerFinancesComponent } from './borrower-finances/borrower-finances.component';
import { MonthlyTotalsModule } from 'app/monthly-totals/monthly-totals.module';

@NgModule({
  declarations: [
    BorrowerFinancesSmartComponent,
    BorrowerFinancesComponent,
  ],
  imports: [
    CommonModule,
    MonthlyTotalsModule
  ],
  exports: [
    BorrowerFinancesSmartComponent
  ],
})
export class BorrowerFinancesModule { }
